<div class="form-group gw-relative">
  <div class="gw-flex gw-flex-col" [class.gw-h-[72px]]="!!label">
    <label
      *ngIf="label"
      class="gw-form-label gw-h-[16px]"
      [attr.for]="effectiveInputId"
      >{{ label }}
      <span *ngIf="required" class="gw-text-status-negative">*</span></label
    >

    <div class="gw-input-group">
      <tui-textfield
        *ngIf="mode === 'date'; else monthInput"
        [iconEnd]="'@tui.close'"
        class="gw-w-full"
      >
        <input
          tuiInputDate
          [id]="effectiveInputId"
          [attr.name]="effectiveInputId"
          [min]="minDate"
          [max]="maxDate"
          [disabled]="disabled"
          [ngModel]="value"
          (ngModelChange)="handleChange($event)"
          (blur)="markTouched()"
          [placeholder]="placeholder"
          class="datepicker hover:gw-bg-background-neutral-1-hover"
        />

        <tui-calendar *tuiTextfieldDropdown [min]="minDate" [max]="maxDate" />
      </tui-textfield>

      <ng-template #monthInput>
        <tui-textfield [iconEnd]="'@tui.close'" class="gw-w-full">
          <input
            tuiInputMonth
            [id]="effectiveInputId"
            [attr.name]="effectiveInputId"
            [min]="minMonth"
            [max]="maxMonth"
            [disabled]="disabled"
            [ngModel]="monthValue"
            (ngModelChange)="handleMonthChange($event)"
            (blur)="markTouched()"
            [placeholder]="placeholder"
            class="datepicker hover:gw-bg-background-neutral-1-hover"
          />

          <tui-calendar-month
            *tuiTextfieldDropdown
            [min]="minMonth"
            [max]="maxMonth"
          />
        </tui-textfield>
      </ng-template>
    </div>
  </div>

  <error-message *ngIf="control" [control]="control"></error-message>
</div>
